import classnames from 'classnames';
import FastAverageColor from 'fast-average-color';
import React, { useEffect, useRef, useState } from 'react';
import adset from '../../images/placeholders/Adset.svg';
import competition from '../../images/placeholders/Competition.svg';
import organization from '../../images/placeholders/Organization.svg';
import player from '../../images/placeholders/Player.svg';
import team from '../../images/placeholders/Team.svg';
import user from '../../images/placeholders/User.svg';
import venue from '../../images/placeholders/Venue.svg';
const placeholderImages = {
    competition,
    player,
    team,
    user,
    organization,
    venue,
    adset
};
const fac = new FastAverageColor();
export const Image = ({ url, placeholder, className, useContrastingBackground = true, id }) => {
    const [contrastClass, setContrastClass] = useState('');
    const imageRef = useRef(null);
    const contrastBackground = () => {
        if (useContrastingBackground && imageRef.current) {
            imageRef.current.onload = () => {
                if (!imageRef.current) {
                    return;
                }
                const avgColor = fac.getColor(imageRef.current);
                if (avgColor.hex === '#ffffff') {
                    imageRef.current && setContrastClass('image--white');
                }
                else if (avgColor.isLight) {
                    imageRef.current && setContrastClass('image--light');
                }
                else {
                    imageRef.current && setContrastClass('image--dark');
                }
            };
        }
    };
    useEffect(() => {
        contrastBackground();
    }, [useContrastingBackground, url]);
    const classNames = classnames('image', className, { [contrastClass]: contrastClass });
    const ImagePlaceholder = placeholder ? placeholderImages[placeholder] : null;
    return (React.createElement("div", { className: classNames }, url ? (React.createElement("img", { id: id, crossOrigin: "anonymous", src: url, ref: imageRef, style: { maxWidth: '100%', maxHeight: '100%' } })) : placeholder ? (React.createElement(ImagePlaceholder, { style: { width: '100%', height: '100%' } })) : null));
};
//# sourceMappingURL=index.js.map